import { squaredMetersToAcres } from '../config/histogramDictionary';
import { yearsForDisplay } from './staticText.config';

const landscape = feature => {
  const { Shape_Area } = feature.graphic.attributes;
  return `<div>Area: ${Math.round(
    Shape_Area * squaredMetersToAcres
  ).toLocaleString()} ac</div>`;
};

const northernPlains = feature => {
  const { Shape_Area } = feature.graphic.attributes;
  return `<div>Area: ${Math.round(
    Shape_Area * squaredMetersToAcres
  ).toLocaleString()} ac</div>`;
};

const southernPlains = feature => {
  const { acres } = feature.graphic.attributes;
  return `<div>Area: ${Math.round(acres).toLocaleString()} ac</div>`;
};

const greatPlains = feature => {
  const { Shape_Area } = feature.graphic.attributes;
  return `<div>Area: ${Math.round(
    Shape_Area * squaredMetersToAcres
  ).toLocaleString()} ac</div>`;
};

const jointVentures = feature => {
  const { Acres } = feature.graphic.attributes;
  return `<div>Area: ${Math.round(Acres).toLocaleString()} ac</div>`;
};

const countyAndMuni = feature => {
  const { County, STATE_NAME, Country, Acres } = feature.graphic.attributes;
  return `<div>Location: ${County}, ${STATE_NAME}, ${Country} </div> <div>Area: ${Math.round(
    Acres
  ).toLocaleString()} ac</div>`;
};

const statesAndProvinces = feature => {
  const { Shape_Area } = feature.graphic.attributes;
  return `<div>Area: ${Math.round(
    Shape_Area * squaredMetersToAcres
  ).toLocaleString()} ac</div>`;
};


const maxYear = yearsForDisplay.max;
const minYear = yearsForDisplay.min;

export const layers = [
  {
    type: 'ImageryLayer',
    options: {
      title: 'Cumulative Plowprint',
      mosaicRule: {
        where: `Year = ${
          maxYear
        }`
      },
      popupEnabled: false,
      url:
        'https://maps.wwfus.org/server/rest/services/Plowprint/pp/ImageServer',
      visible: false,
      renderingRule: {
        functionName: 'symbology_pp'
      },
      infoButton:
        'The cumulative footprint of agriculture based on data from the Cropland Data Layer in the U.S. and the Annual Crop Inventory in Canada.',
      queryInfo: {
        field: 'Year',
        type: 'range',
        values: {
          min: minYear,
          max: maxYear
        }
      }
    }
  },
  {
    type: 'MapImageLayer',
    grouping: 'Administrative Areas',
    id: 'topLevel',
    options: {
      url:
        'https://maps.wwfus.org/server/rest/services/Plowprint/Administrative_boundaries/MapServer',
      title: 'Administrative Boundaries',
      id: 'topLevel',
      sublayers: [
        {
          id: 0,
          label: 'Landscape Conservation Cooperatives',
          visible: false,
          popupTemplate: {
            title: 'Area Name: {area_names}',
            content: landscape,
            actions: [
              {
                id: 'run-analysis',
                title: 'Run Analysis'
              }
            ],
            outFields: ['Area_Num', 'Shape_Area', 'OBJECTID']
          }
        },
        {
          id: 1,
          label: 'Northern Great Plains',
          visible: false,
          popupTemplate: {
            title: 'Northern Great Plains',
            content: northernPlains,
            actions: [
              {
                id: 'run-analysis',
                title: 'Run Analysis'
              }
            ],
            outFields: ['Shape_Area', 'OBJECTID']
          }
        },
        {
          id: 2,
          label: 'Southern Great Plains',
          visible: false,
          popupTemplate: {
            title: 'Southern Great Plains',
            content: southernPlains,
            actions: [
              {
                id: 'run-analysis',
                title: 'Run Analysis'
              }
            ],
            outFields: ['acres', 'OBJECTID']
          }
        },
        {
          id: 3,
          label: 'CEC Great Plains',
          visible: false,
          popupTemplate: {
            title: 'CEC Great Plains',
            content: greatPlains,
            actions: [
              {
                id: 'run-analysis',
                title: 'Run Analysis'
              }
            ],
            outFields: ['Shape_Area', 'OBJECTID']
          }
        },
        {
          id: 4,
          label: 'North American Joint Ventures',
          visible: false,
          popupTemplate: {
            title: 'Joint Venture: {JV}',
            content: jointVentures,
            actions: [
              {
                id: 'run-analysis',
                title: 'Run Analysis'
              }
            ],
            outFields: ['JV', 'Acres', 'OBJECTID']
          }
        },
        {
          id: 5,
          label: 'Counties and Municipalities',
          visible: false,
          popupTemplate: {
            title: 'Counties and Municipalities: {County}',
            content: countyAndMuni,
            actions: [
              {
                id: 'run-analysis',
                title: 'Run Analysis'
              }
            ],
            outFields: ['County', 'STATE_NAME', 'Country', 'Acres', 'OBJECTID']
          }
        },
        {
          id: 6,
          label: 'States and Provinces',
          visible: true,
          popupTemplate: {
            title: 'States and Provinces: {Name_1}',
            content: statesAndProvinces,
            actions: [
              {
                id: 'run-analysis',
                title: 'Run Analysis'
              }
            ],
            outFields: ['Shape_Area', 'Name_1', 'OBJECTID']
          }
        }
      ],
      visible: true
    }
  },
  {
    type: 'ImageryLayer',
    options: {
      title: 'Plowprint Composition',
      mosaicRule: {
        where: `Year = ${
          maxYear
        }`
      },
      popupEnabled: false,
      url:
        'https://maps.wwfus.org/server/rest/services/Plowprint/pp_comp/ImageServer',
      visible: true,
      renderingRule: {
        functionName: 'symbology_pp_comp'
      },
      infoButton:
        'The Plowprint layer broken into land cover classes for the given year of data.',
      queryInfo: {
        field: 'Year',
        type: 'range',
        values: {
          min: minYear,
          max: maxYear
        }
      }
    }
  },
  {
    type: 'ImageryLayer',
    options: {
      mosaicRule: {
        where: `Year = ${
          maxYear
        }`
      },
      popupEnabled: false,
      url:
        'https://maps.wwfus.org/server/rest/services/Plowprint/pp_own/ImageServer',
      title: 'Plowprint Ownership',
      visible: false,
      renderingRule: {
        functionName: 'symbology_int_own'
      },
      infoButton: 'Plowprint data identified by current ownership status.',
      queryInfo: {
        field: 'Year',
        type: 'range',
        values: {
          min: minYear,
          max: maxYear
        }
      }
    }
  },
  {
    type: 'ImageryLayer',
    options: {
      mosaicRule: {
        where: `Year = ${
          maxYear
        }`
      },
      popupEnabled: false,
      url:
        'https://maps.wwfus.org/server/rest/services/Plowprint/ppannexp/ImageServer',
      title: 'Plowprint Annual Expansion',
      visible: false,
      renderingRule: {
        functionName: 'symbology_ppannexp'
      },
      infoButton:
        'Agricultural cover type of new Plowprint (cropland expansion).',
      queryInfo: {
        field: 'Year',
        type: 'range',
        values: {
          min: minYear + 1,
          max: maxYear
        }
      }
    }
  },
  {
    type: 'ImageryLayer',
    options: {
      title: `Plowprint Expansion (${minYear}-${maxYear})`,
      popupEnabled: false,
      url:
        'https://maps.wwfus.org/server/rest/services/Plowprint/ppexp/ImageServer',
      visible: false,
      renderingRule: {
        functionName: 'symbology_ppannexp'
      },
      infoButton:
        `Agricultural cover type of new Plowprint (cropland expansion ${minYear}-${maxYear}).`
    }
  },
  {
    type: 'ImageryLayer',
    grouping: 'Soil Quality and Conversion Risk',
    options: {
      mosaicRule: {
        where: `Year = ${maxYear}`
      },
      title: 'Soil Quality and Conversion Risk (Plowprint)',
      definitionExpression: "Name = 'PP20_conrisk'",
      popupEnabled: false,
      url:
        'https://maps.wwfus.org/server/rest/services/Plowprint/soil/ImageServer',
      visible: false,
      renderingRule: {
        functionName: 'symbology_soil'
      },
      infoButton:
        'Plowprint data intersected with a Conversion Risk model to show the suitability of the soil for agricultural land use.'
    }
  },
  {
    type: 'ImageryLayer',
    options: {
      title: 'Intact Extent',
      mosaicRule: {
        where: `Year = ${
          maxYear
        }`
      },
      popupEnabled: false,
      url:
        'https://maps.wwfus.org/server/rest/services/Plowprint/int/ImageServer',
      visible: false,
      renderingRule: {
        functionName: 'symbology_int'
      },
      infoButton:
        'Land that is not in cropland (as determined by the Plowprint) or classified as developed or permanent water.',
      queryInfo: {
        field: 'Year',
        type: 'range',
        values: {
          min: minYear,
          max: maxYear
        }
      }
    }
  },
  {
    type: 'ImageryLayer',
    options: {
      title: 'Intact Habitat',
      mosaicRule: {
        where: `Year = ${
          maxYear
        }`
      },
      popupEnabled: false,
      url:
        'https://maps.wwfus.org/server/rest/services/Plowprint/int_habitat/ImageServer',
      visible: false,
      renderingRule: {
        functionName: 'symbology_int_habitat'
      },
      infoButton:
        'The Intact layer broken into land cover classes for a given year.',
      queryInfo: {
        field: 'Year',
        type: 'range',
        values: {
          min: minYear,
          max: maxYear
        }
      }
    }
  },
  {
    type: 'ImageryLayer',
    options: {
      mosaicRule: {
        where: `Year = ${
          maxYear
        }`
      },
      popupEnabled: false,
      url:
        'https://maps.wwfus.org/server/rest/services/Plowprint/int_own/ImageServer',
      title: 'Intact Ownership',
      visible: false,
      renderingRule: {
        functionName: 'symbology_int_own'
      },
      infoButton: 'Intact data identified by current ownership status.',
      queryInfo: {
        field: 'Year',
        type: 'range',
        values: {
          min: minYear,
          max: maxYear
        }
      }
    }
  },
  {
    type: 'ImageryLayer',
    grouping: 'Soil Quality and Conversion Risk',
    options: {
      mosaicRule: {
        where: `Year = ${
          maxYear
        }`
      },
      title: 'Soil Quality and Conversion Risk (Intact)',
      definitionExpression: "Name = 'INT20_conrisk'",
      popupEnabled: false,
      url:
        'https://maps.wwfus.org/server/rest/services/Plowprint/soil/ImageServer',
      visible: false,
      renderingRule: {
        functionName: 'symbology_soil'
      },
      infoButton:
        'Intact data intersected with a Conversion Risk model to show the likelihood of future agricultural conversion.'
    }
  },
  {
    type: 'ImageryLayer',
    grouping: 'Soil Quality and Conversion Risk',
    options: {
      mosaicRule: {
        where: `Year = ${
          maxYear
        }`
      },
      title: 'Open Water',
      definitionExpression: "Name = 'h2o_1_gp_2019'", // ! update
      popupEnabled: false,
      url:
        'https://maps.wwfus.org/server/rest/services/Plowprint/waterdev/ImageServer',
      visible: false,
      renderingRule: {
        functionName: 'symbology_waterdev_water'
      }
    }
  },
  {
    type: 'ImageryLayer',
    grouping: 'Soil Quality and Conversion Risk',
    options: {
      mosaicRule: {
        where: `Year = ${
          maxYear
        }`
      },
      title: 'Developed Area',
      definitionExpression: "Name = 'dev_1_gp'",
      popupEnabled: false,
      url:
        'https://maps.wwfus.org/server/rest/services/Plowprint/waterdev/ImageServer',
      visible: false,
      renderingRule: {
        functionName: 'symbology_waterdev_developed'
      }
    }
  }
];
